import styled from 'styled-components'
import { themeGet } from 'styled-system'
import theme from 'styles/theme'
import { CtaLabel } from 'components/Typography'

export const OpenHoursContent = styled.button`
  max-width: ${theme.containterMaxWidth};
  margin: 0 auto;
  position: relative;
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  padding: 0 ${theme.space[3]};
  height: 70px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${theme.mediaQueries.small} {
    justify-content: center;
  }

  span {
    color: ${(props) => props.theme.colors.dark};
    margin-right: 5px;
    margin-left: 5px;

    html[dir='rtl'] & {
      transform: rotate(0deg);
    }
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`

export const VirtualBoutiqueOnlyContent = styled.div`
  max-width: ${theme.containterMaxWidth};
  margin: 0 auto;
  position: relative;
  border: none;
  background: none;
  outline: none;
  padding: 0 ${theme.space[3]};
  height: 70px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  ${theme.mediaQueries.small} {
    justify-content: center;
  }

  span {
    color: ${themeGet('colors.sagemedium')};
    margin-right: 5px;
    margin-left: 5px;

    html[dir='rtl'] & {
      transform: rotate(0deg);
    }
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`

export const OpenHoursWrapper = styled.div`
  display: block;
  position: relative;

  ${(props) =>
    props.background === 'Grey'
      ? `
        background: ${props.theme.colors.sagelightToGreen};
    `
      : `
        :before {
            content: '';
            background: ${props.theme.colors.sagelightToGreen};
            width: 100%;
            height: 1px;
            bottom: 0;
            left: 0;
            position: absolute;
        }
        ${theme.mediaQueries.medium} {
            :before {
                width: calc(100% - 80px);
                left: 40px;
            }
        }
    `}
`

export const Divider = styled.span`
  display: inline-block;
  margin: -3px ${theme.space[1]} 0;
  position: relative;
  color: ${(props) =>
    props.background === 'Grey'
      ? props.theme.colors.dark
      : props.theme.colors.darkToGreen} !important;
`

export const OpenHoursLabel = styled(CtaLabel)`
  ${(props) =>
    props.bold &&
    `
    color: ${
      props.background === 'Grey'
        ? props.theme.colors.dark
        : props.theme.colors.darkToGreen
    } !important;
  `}

  ${(props) =>
    !props.bold &&
    `
   color:${
     props.background === 'Grey'
       ? props.theme.colors.dark
       : props.theme.colors.darkToGreen
   } !important;
  `}
`
